import { createFileRoute } from '@tanstack/react-router'
import SerieContainer from 'Serie/containers/SerieContainer'
import { claimTypesEnum } from 'User/utils/claims'

import { Guard } from '../../-guard'

export const Route = createFileRoute('/series/list/$serieId')({
    component: () => (
        <Guard claims={[claimTypesEnum.enum.opus_work]}>
            <SerieContainer />
        </Guard>
    ),
})
